var WizardStepSlots;
(function (WizardStepSlots) {
    WizardStepSlots["CONTENT"] = "wizard-step-content";
    WizardStepSlots["RESULT"] = "wizard-step-result";
})(WizardStepSlots || (WizardStepSlots = {}));
export { WizardStepSlots, };
//# sourceMappingURL=wizard-step-constants.js.map